export enum StorageKeys {
  extensionInfo = "extensionInfo",
}
export interface IState {
  lastExtension?: string;
}
